// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__1Q-CQ","link":"PrivacyPolicy_link__3oTQH"};